{
  "version": 1,
  "asset_id": "2500ddef-8417-40c4-b257-b45fd3c986ba",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/2500ddef-8417-40c4-b257-b45fd3c986ba/hiatal-type-4-v2-800.jpg",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/2500ddef-8417-40c4-b257-b45fd3c986ba/hiatal-type-4-v2-800.jpg",
  "original_filename": "hiatal-type-4-v2-800.jpg",
  "size": 72769,
  "content_type": "image/jpeg",
  "created_at": "2026-09-24T19:31:06Z"
}
